module.exports = __webpack_public_path__ + "static/media/Group_569.e525a6c6.svg";